import { getParLevelForProduct } from './parLevelPaywall'

const trackParLevelEvent = (eventName, properties = {}) => {
  try {
    if (typeof window !== 'undefined' && window.analytics?.track) {
      window.analytics.track(eventName, properties)
    }
  } catch (_) {
    // Analytics not available; ignore
  }
}

export const trackParLevelSet = properties =>
  trackParLevelEvent('par_level_set', properties)

export const trackParLevelUpdated = properties =>
  trackParLevelEvent('par_level_updated', properties)

export const trackParLevelPaywallTriggered = properties =>
  trackParLevelEvent('par_level_paywall_triggered', properties)

export const trackParLevelSaveIfChanged = ({
  venueId,
  venueProductId,
  previousParLevel,
  newParLevel,
}) => {
  const previous = getParLevelForProduct({ parLevel: previousParLevel })
  const next = getParLevelForProduct({ parLevel: newParLevel })

  if (previous === next) {
    return
  }

  const properties = {
    venueId,
    venueProductId,
    parLevel: next,
    previousParLevel: previous,
  }

  if (previous === 0 && next > 0) {
    trackParLevelSet(properties)
    return
  }

  if (previous > 0) {
    trackParLevelUpdated(properties)
  }
}
